import React from 'react';
import { Star, Check, Droplet, Wind, Sun } from 'lucide-react';
export const Services = () => {
  return <section id="servicios" className="py-16 bg-beige-100" data-id="element-375">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-376">
        <div className="text-center mb-16" data-id="element-377">
          <h2 className="text-3xl md:text-4xl font-serif text-neutral-900 mb-4" data-id="element-378">
            Los tratamientos que{' '}
            <span className="metallic-gold-text italic" data-id="element-379">ofrecemos</span>
          </h2>
          <div className="w-24 h-1 bg-gold-300 mx-auto rounded-full" data-id="element-380"></div>
        </div>

        <div className="grid lg:grid-cols-12 gap-8" data-id="element-381">
          {/* Featured Service */}
          <div className="lg:col-span-12" data-id="element-382">
            <div className="bg-white rounded-[2rem] p-8 md:p-12 shadow-xl border-2 border-gold-300 relative overflow-hidden" data-id="element-383">
              <div className="absolute top-0 right-0 metallic-gold-button text-white px-6 py-2 rounded-bl-2xl font-medium text-sm tracking-wide shadow-sm flex items-center" data-id="element-384">
                <Star className="w-4 h-4 mr-2 fill-current" data-id="element-385" /> TRATAMIENTO
                ESTRELLA
              </div>

              <div className="max-w-3xl" data-id="element-386">
                <h3 className="text-3xl font-serif text-neutral-900 mb-4 mt-4 md:mt-0" data-id="element-387">
                  Alisado con Nanoplastia Orgánica
                </h3>
                <p className="text-neutral-600 mb-8 text-lg" data-id="element-388">
                  Sin formaldehído. Alisado de hasta un 80%. Apto para todo tipo
                  de cabello. El tratamiento que transforma tu melena desde
                  adentro hacia afuera.
                </p>

                <div className="grid sm:grid-cols-2 gap-4" data-id="element-389">
                  {['Alisa sin dañar', 'Elimina el frizz desde la primera sesión', 'Aporta brillo y suavidad naturales', 'Repara desde el interior', 'Resultados de 3 a 8 meses (hasta 10 con buen mantenimiento)', 'Apto para cabellos teñidos, decolorados, embarazadas y niñas'].map((benefit, idx) => <div key={idx} className="flex items-start" data-id="element-390">
                      <Check className="w-5 h-5 metallic-gold-icon mr-3 flex-shrink-0 mt-0.5" data-id="element-391" />
                      <span className="text-neutral-700" data-id="element-392">{benefit}</span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>

          {/* Other Services Grid */}
          <div className="lg:col-span-6 bg-white rounded-[2rem] p-8 shadow-md border border-beige-200" data-id="element-393">
            <div className="w-12 h-12 bg-beige-100 rounded-xl flex items-center justify-center mb-6" data-id="element-394">
              <Droplet className="w-6 h-6 metallic-gold-icon" data-id="element-395" />
            </div>
            <h3 className="text-2xl font-serif text-neutral-900 mb-3" data-id="element-396">
              Botox Capilar
            </h3>
            <p className="text-neutral-600 leading-relaxed" data-id="element-397">
              Nutrición intensiva que reconstruye la fibra capilar, rellena
              daños y devuelve el volumen y suavidad que creías perdidos. Ideal
              para cabellos dañados por el calor, la decoloración o el tiempo.
            </p>
          </div>

          <div className="lg:col-span-6 bg-white rounded-[2rem] p-8 shadow-md border border-beige-200" data-id="element-398">
            <div className="w-12 h-12 bg-beige-100 rounded-xl flex items-center justify-center mb-6" data-id="element-399">
              <Droplet className="w-6 h-6 metallic-gold-icon" data-id="element-400" />
            </div>
            <h3 className="text-2xl font-serif text-neutral-900 mb-3" data-id="element-401">
              Hidratación Capilar
            </h3>
            <p className="text-neutral-600 mb-4" data-id="element-402">
              Recomendada cada 15 a 30 días después de tu alisado para:
            </p>
            <ul className="space-y-2" data-id="element-403">
              {['Prolongar la duración del tratamiento', 'Mantener el cabello sellado y saludable', 'Potenciar el brillo y la suavidad', 'Prevenir daños a largo plazo'].map((item, i) => <li key={i} className="flex items-start text-sm text-neutral-600" data-id="element-404">
                  <Check className="w-4 h-4 metallic-gold-icon mr-2 flex-shrink-0 mt-0.5" data-id="element-405" />{' '}
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="lg:col-span-6 bg-white rounded-[2rem] p-8 shadow-md border border-beige-200" data-id="element-406">
            <div className="w-12 h-12 bg-beige-100 rounded-xl flex items-center justify-center mb-6" data-id="element-407">
              <Wind className="w-6 h-6 metallic-gold-icon" data-id="element-408" />
            </div>
            <h3 className="text-2xl font-serif text-neutral-900 mb-3" data-id="element-409">
              Ozonoterapia Capilar
            </h3>
            <p className="text-neutral-600 mb-4" data-id="element-410">
              Un tratamiento purificador de alta tecnología que:
            </p>
            <ul className="space-y-2" data-id="element-411">
              {['Limpia profundamente el cuero cabelludo', 'Regenera las células y folículos pilosos', 'Contribuye a detener la caída del cabello', 'Elimina hongos sin dañar el cuero cabelludo', 'Aporta brillo, vitalidad y suavidad'].map((item, i) => <li key={i} className="flex items-start text-sm text-neutral-600" data-id="element-412">
                  <Check className="w-4 h-4 metallic-gold-icon mr-2 flex-shrink-0 mt-0.5" data-id="element-413" />{' '}
                  {item}
                </li>)}
            </ul>
          </div>

          
        </div>
      </div>
    </section>;
};